!(function () {
  "use strict";
  var e = {
      671: function (e, t, r) {
        r.d(t, {
          Bb: function () {
            return a;
          },
          IV: function () {
            return c;
          },
        });
        var n = r(4559);
        const s = document.getElementById("nav-wrapper"),
          c = (e) => {
            (0, n.jW)(!1),
              ((e) => {
                let t;
                if (
                  (e.classList.remove("nav--secondary-menu-open"),
                  (t = e.classList.contains("nav--mobile")
                    ? e.querySelector(".nav--mobile__inner-container")
                    : e.querySelector(".nav__secondary-menu")),
                  window.matchMedia("(max-width: 640px)").matches)
                ) {
                  const r = e.querySelector(".nav__main-menu-link--active");
                  r && r.classList.remove("nav__main-menu-link--active"),
                    e.querySelector(".nav__main-menu-link--active") &&
                      e
                        .querySelector(".nav__main-menu-link--active")
                        .classList.remove("nav__main-menu-link--active"),
                    e
                      .querySelectorAll(
                        ".nav__secondary-menu__item--animate-in"
                      )
                      .forEach((e) => {
                        e.classList.remove(
                          "nav__secondary-menu__item--animate-in"
                        ),
                          window.setTimeout(() => {
                            e.classList.remove(
                              "nav__secondary-menu__item--visible"
                            ),
                              (t.height = "auto");
                          }, 300);
                      });
                }
              })(e),
              ((e, t) => {
                e.props.activeMenu = t;
              })(e, 0),
              s.removeAttribute("style"),
              (s.props.navMargin = 0),
              (s.props.submenuOpen = !1),
              e.classList.remove(
                "nav--open",
                "nav--secondary-menu-open",
                "animation-delay"
              ),
              document
                .querySelectorAll(".megamenu-opener, .menu-trigger")
                .forEach((e) => {
                  e.classList.remove("active");
                });
          };
        document.querySelector(".sticky-subheader"),
          document.querySelector("#main-collection-filters");
        const o = document.querySelectorAll(".predictive-search"),
          i = document.getElementById("overlay"),
          a = () => {
            i.classList.remove("open"),
              document.body.classList.remove("active", "search"),
              o.forEach((e) => {
                e.classList.remove("open"),
                  (0, n.qF)(e.closest(".predictive-search-wrapper"));
              });
          };
      },
      4559: function (e, t, r) {
        r.d(t, {
          My: function () {
            return i;
          },
          aO: function () {
            return n;
          },
          jW: function () {
            return s;
          },
          oM: function () {
            return l;
          },
          qF: function () {
            return u;
          },
          sg: function () {
            return a;
          },
        });
        const n = async function () {
            let e, t;
            try {
              e = await fetch(...arguments);
            } catch (e) {
              t = e;
            }
            return { response: e, error: t };
          },
          s = function () {
            let e =
              arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
            const t = window.innerWidth - document.body.offsetWidth,
              r = document.getElementById("nav-wrapper");
            e
              ? (document.body.classList.add("no-scroll"),
                (document.body.style.paddingRight = t + "px"),
                (r.style.paddingRight = t + "px"))
              : (document.body.classList.remove("no-scroll"),
                (document.body.style.paddingRight = "0px"),
                (r.style.paddingRight = "0px"));
          };
        let c = () => {};
        const o = (e) => {
            "Escape" === e.key &&
              (c(), window.removeEventListener("keydown", o));
          },
          i = function () {
            let e =
                arguments.length > 0 && void 0 !== arguments[0] && arguments[0],
              t = arguments.length > 1 ? arguments[1] : void 0;
            t && (c = t),
              e && window.addEventListener("keydown", o),
              e || window.removeEventListener("keydown", o);
          };
        function a(e, t) {
          const r = this;
          let n;
          return function () {
            for (var s = arguments.length, c = new Array(s), o = 0; o < s; o++)
              c[o] = arguments[o];
            clearTimeout(n),
              (n = setTimeout(function () {
                return e.apply(r, c);
              }, t));
          };
        }
        document.querySelectorAll(".local-scroll").forEach((e) => {
          e.addEventListener("click", (e) => {
            e.preventDefault(), e.stopPropagation();
            const t = e.target.getAttribute("href");
            ((e) => {
              Math.easeInOutQuad = function (e, t, r, n) {
                return (e /= n / 2) < 1
                  ? (r / 2) * e * e + t
                  : (-r / 2) * (--e * (e - 2) - 1) + t;
              };
              const t = document.getElementById("grid-archive-header"),
                r = document.getElementById("nav-wrapper");
              let n = 0,
                s = 0;
              t && (n = t.offsetHeight + 50), r && (s = r.offsetHeight + 50);
              const c = e.offsetTop - n - s,
                o = window.scrollY,
                i = c - o;
              let a = 0;
              const d = () => {
                a += 5;
                const e = Math.easeInOutQuad(a, o, i, 200);
                window.scrollTo(0, e), a < 200 && setTimeout(d, 5);
              };
              d();
            })(document.querySelector(t));
          });
        });
        const d = {};
        function l(e) {
          let t =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : e;
          const r = (function (e) {
              return Array.from(
                e.querySelectorAll(
                  'summary, a[href], button:not([disabled]), [tabindex]:not([tabindex^="-"]), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe'
                )
              );
            })(e),
            n = r[0],
            s = r[r.length - 1];
          u(),
            (d.focusin = (t) => {
              (t.target !== e && t.target !== s && t.target !== n) ||
                document.addEventListener("keydown", d.keydown);
            }),
            (d.focusout = function () {
              document.removeEventListener("keydown", d.keydown);
            }),
            (d.keydown = function (t) {
              "TAB" === t.code.toUpperCase() &&
                (t.target !== s ||
                  t.shiftKey ||
                  (t.preventDefault(), n.focus()),
                (t.target !== e && t.target !== n) ||
                  !t.shiftKey ||
                  (t.preventDefault(), s.focus()));
            }),
            document.addEventListener("focusout", d.focusout),
            document.addEventListener("focusin", d.focusin),
            t.focus();
        }
        function u(e) {
          document.removeEventListener("focusin", d.focusin),
            document.removeEventListener("focusout", d.focusout),
            document.removeEventListener("keydown", d.keydown),
            e && e.focus();
        }
      },
    },
    t = {};
  function r(n) {
    var s = t[n];
    if (void 0 !== s) return s.exports;
    var c = (t[n] = { exports: {} });
    return e[n](c, c.exports, r), c.exports;
  }
  (r.d = function (e, t) {
    for (var n in t)
      r.o(t, n) &&
        !r.o(e, n) &&
        Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
  }),
    (r.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (function () {
      var e = r(4559),
        t = r(671);
      const n = document.getElementById("nav-wrapper"),
        s = document.getElementById("overlay"),
        c = (e) => {
          window.matchMedia("(min-width: 1024px)").matches &&
            (e.target.classList.contains("search-trigger") ||
              e.target.classList.contains("search-icon") ||
              a());
        },
        o = () => {
          const e = n.querySelector(".predictive-search"),
            t = n.offsetHeight;
          window.matchMedia("(max-width: 1023px)").matches && e
            ? (e.style.top = `${t}px`)
            : e && (e.style.top = "");
        },
        i = (0, e.sg)(o, 100);
      window.addEventListener("resize", i), o();
      const a = () => {
        (0, t.Bb)(), n.removeEventListener("click", c);
      };
      class d extends HTMLElement {
        constructor() {
          super(),
            (this.style.zIndex = "10"),
            (this.instances = this.querySelectorAll(
              ".predictive-search-container"
            )),
            (this.parser = new DOMParser()),
            (this.resultsContainers =
              this.querySelectorAll(".predictive-search")),
            (this.inputs = this.querySelectorAll(
              "#Search--header, #SearchMobile.search-input"
            ));
          const r = sessionStorage.getItem("recentSearches");
          (this.recentSearches = r ? JSON.parse(r) : []),
            this.inputs.forEach((t) => {
              t.addEventListener(
                "keyup",
                (0, e.sg)(this.search.bind(this), 300)
              );
            });
          const c = this.querySelectorAll(".predictive-search__mobile-close"),
            o = document.querySelector(".nav--mobile");
          s.addEventListener("click", () => {
            (0, t.Bb)(), (0, e.My)(!1), (0, e.jW)(!1);
          }),
            n.addEventListener("click", () => {
              window.matchMedia("(max-width: 1024px)").matches &&
                ((0, t.Bb)(), (0, e.My)(!1), (0, e.jW)(!1));
            }),
            c.forEach((e) => {
              e.addEventListener("click", () => {
                a();
              });
            }),
            this.resultsContainers.forEach((e) => {
              e.addEventListener("click", (e) => {
                e.stopPropagation();
              });
            }),
            document.querySelectorAll(".search-trigger").forEach((e) => {
              e.addEventListener("click", (r) => {
                r.stopPropagation(),
                  this.openPredictiveSearch(e),
                  this.closeAllMenus(),
                  (0, t.IV)(o);
              }),
                e.addEventListener("focus", () => {
                  "input" === e.tagName.toLowerCase() &&
                    "search" === e.type &&
                    (this.openPredictiveSearch(e),
                    this.closeAllMenus(),
                    (0, t.IV)(o));
                });
            }),
            this.populateRecentSearches(),
            this.addListeners();
        }
        populateRecentSearches(e) {
          const t = e || document,
            r = t.querySelector("#search-sidebar"),
            n = t.querySelector(".recent-searches");
          if ((n && n.remove(), this.recentSearches.length)) {
            const e = document.createElement("div");
            e.classList.add("search-sidebar__list", "recent-searches");
            const t = document.createElement("span");
            t.classList.add(
              "search-sidebar__header",
              "text-md",
              "recent-searches__header"
            ),
              (t.innerText = `${searchStrings.recent_searches}`);
            const n = document.createElement("button");
            (n.type = "button"),
              n.classList.add("search-sidebar__clear", "text-xs"),
              (n.innerText = `${searchStrings.clear_all}`),
              t.append(n),
              e.append(t);
            const s = document.createElement("ul");
            this.recentSearches.forEach((e) => {
              const t = document.createElement("li");
              t.classList.add("search-sidebar__item", "recent-searches__item");
              const r = document.createElement("button");
              (r.type = "button"),
                (r.innerHTML = e),
                r.classList.add("search-sidebar__button");
              const n = document.createElement("button");
              (n.type = "button"),
                n.classList.add("search-sidebar__remove"),
                (n.innerHTML =
                  "<span class='icon loaded' aria-hidden='true' focusable='false' role='presentation'>close</span>"),
                (n.dataset.search = e),
                t.appendChild(n),
                t.appendChild(r),
                s.appendChild(t);
            }),
              e.appendChild(s),
              r.prepend(e);
          }
        }
        addListeners() {
          this.querySelectorAll(".search-sidebar__button").forEach((e) => {
            e.onclick = () => {
              this.inputs.forEach((t) => {
                (t.value = e.innerHTML), this.search({ target: t });
              });
            };
          }),
            this.querySelectorAll(".search-sidebar__remove").forEach((e) => {
              const t = e.dataset.search;
              t &&
                (e.onclick = () => {
                  const r = this.recentSearches.indexOf(t);
                  if (
                    r > -1 &&
                    (this.recentSearches.splice(r, 1),
                    sessionStorage.setItem(
                      "recentSearches",
                      JSON.stringify(this.recentSearches)
                    ),
                    e.closest(".recent-searches__item").remove(),
                    !this.recentSearches.length)
                  ) {
                    const e = this.querySelector(".recent-searches");
                    e && e.remove();
                  }
                });
            });
          const e = this.querySelector(".search-sidebar__clear");
          e &&
            (e.onclick = () => {
              (this.recentSearches = []),
                sessionStorage.removeItem("recentSearches");
              const e = this.querySelector(".recent-searches");
              e && e.remove();
            });
        }
        closeAllMenus() {
          document
            .getElementById("nav-wrapper")
            .querySelectorAll("details.megamenu-open > summary")
            .forEach((e) => {
              e.classList.remove("active"),
                e.parentNode.removeAttribute("open");
            });
        }
        openPredictiveSearch(t) {
          const r = t.getAttribute("data-predictive-search");
          if (r) {
            const t = document.querySelector(
                `#predictive-search[data-predictive-search="${r}"]`
              ),
              o = this.querySelectorAll(".predictive-search");
            if (
              (o &&
                o.forEach((e) => {
                  e.classList.remove("open");
                }),
              t)
            ) {
              const r = t.closest(".predictive-search-wrapper");
              t.classList.add("open"),
                document.body.classList.add("active", "search"),
                (0, e.My)(!0, a),
                n.addEventListener("click", c),
                s.classList.add("open"),
                setTimeout(() => {
                  const e = t.querySelector("#SearchMobile.search-input");
                  e && e.focus();
                }, "100"),
                (0, e.oM)(r, t),
                this.defaultView ||
                  (this.defaultView = t
                    .querySelector(".predictive-search__results-container")
                    .cloneNode(!0));
            }
          }
        }
        async search(t) {
          const r = t.target.getAttribute("data-predictive-search"),
            n = document.querySelector(
              '#predictive-search[data-predictive-search="' + r + '"]'
            ),
            s = t.target.value,
            c = n.querySelector(".predictive-search__results-container");
          if (
            (window.matchMedia("(min-width: 1024px)").matches
              ? (document.querySelector("#SearchMobile.search-input").value = s)
              : (document.querySelector("#Search--header").value = s),
            !s && this.defaultView)
          )
            return (
              this.populateRecentSearches(this.defaultView),
              (c.innerHTML = this.defaultView.innerHTML),
              void this.addListeners()
            );
          c.classList.add("loading");
          const o =
              window.Shopify.routes.root +
              `search/suggest?q=${s}&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor&section_id=predictive-search`,
            { response: i, error: a } = await (0, e.aO)(o);
          if (a || !i.ok) return;
          const d = await i.text(),
            l = this.parser
              .parseFromString(d, "text/html")
              .querySelector("#shopify-section-predictive-search");
          this.recentSearches.includes(s) ||
            (this.recentSearches.length > 4 && this.recentSearches.pop(),
            this.recentSearches.unshift(s),
            sessionStorage.setItem(
              "recentSearches",
              JSON.stringify(this.recentSearches)
            ),
            this.populateRecentSearches(this.defaultView)),
            this.populateRecentSearches(l),
            [".search-sidebar", ".search-products"].forEach((e) => {
              const t = l.querySelector(e);
              if (!t) return;
              const r = c.querySelector(e);
              r && (r.innerHTML = t.innerHTML);
            }),
            this.addListeners(),
            c.classList.remove("loading");
        }
      }
      window.customElements.get("predictive-search") ||
        window.customElements.define("predictive-search", d);
    })();
})();
